import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import _without from 'lodash/without';
import PropTypes from 'prop-types';
// Core components
import Checkbox from 'components/core/Checkbox';
// Core components
import TextField from 'components/core/TextField';
// Models
import { callbackSubscriptionsList } from 'models/user';

const UserCallbacks = ({
  cbVersion, cbUri, cbSubscriptions, errors, onChange, onKeyPress,
}) => {
  const handleSubscriptionCheck = (cbSubscription, checked) => {
    const newCbSubscriptions = checked ? [...cbSubscriptions, cbSubscription] : _without(cbSubscriptions, cbSubscription);
    onChange({ cbVersion, cbUri, cbSubscriptions: newCbSubscriptions });
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-sm-12">
          <TextField
            label={<LocalizedMessage id="field.versionVx" />}
            errorText={_get(errors, 'version')}
            value={cbVersion}
            onChange={(value) => onChange({ cbVersion: value, cbUri, cbSubscriptions })}
            onKeyPress={onKeyPress}
          />
        </div>
        <div className="col-lg-9 col-md-8 col-sm-12">
          <TextField
            label={<LocalizedMessage id="field.uri" />}
            errorText={_get(errors, 'uri')}
            value={cbUri}
            onChange={(value) => onChange({ cbVersion, cbUri: value, cbSubscriptions })}
            onKeyPress={onKeyPress}
          />
        </div>
      </div>
      <div className="row pt-3">
        {_map(callbackSubscriptionsList, (cbSubscription) => (
          <div key={cbSubscription} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Checkbox
              label={<LocalizedMessage id={`userCallback.${cbSubscription}`} />}
              checked={_includes(cbSubscriptions, cbSubscription)}
              onChange={(checked) => handleSubscriptionCheck(cbSubscription, checked)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

UserCallbacks.propTypes = {
  cbVersion: PropTypes.string.isRequired,
  cbUri: PropTypes.string.isRequired,
  cbSubscriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  errors: PropTypes.shape({
    version: PropTypes.string,
    uri: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
};

UserCallbacks.defaultProps = {
  errors: null,
};

module.exports = UserCallbacks;



// WEBPACK FOOTER //
// ./routes/app/routes/users/assets/main/UserCallbacks.js